module.exports = __webpack_public_path__ + "img/02-12.d560d60f.png";